// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";

import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";



// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {

  apiKey: "AIzaSyAlfe0FvObhKkorP4P2YjNmfF0WxGd7NTY",

  authDomain: "shopping-list-4196d.firebaseapp.com",

  projectId: "shopping-list-4196d",

  storageBucket: "shopping-list-4196d.appspot.com",

  messagingSenderId: "393852177601",

  appId: "1:393852177601:web:c4f1d5c5f5bc17e9625840",

  measurementId: "G-192SVW6ELC"

};

/*
apiKey: process.env.APIKEY,

  authDomain: process.env.AUTHDOMAIN,

  projectId: process.env.PROJECTID,

  storageBucket: process.env.STORAGEBUCKET,

  messagingSenderId: process.env.MESSAGINGSENDERID,

  appId: process.env.APPID,

  measurementId: process.env.MEASUREMENTID
*/
// Initialize Firebase

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const auth = getAuth(app);

const analytics = getAnalytics(app);

export { app, analytics, db, auth }